const AZURE_ENVS = {
  PRODUCTION: 'production',
  STAGING: 'staging',
  PREPROD: 'preprod',
  LOCAL: 'local'
} as const;

const NODE_ENVS = {
  DEVELOPMENT: 'development',
  TEST: 'test',
  PRODUCTION: 'production',
} as const;

export class EnvUtils {

  static getAzureEnv() {
    return process?.env?.AZURE_ENV;
  }

  static getNodeEnv() {
    return process?.env?.NODE_ENV;
  }

  static azureEnvIs(azureEnv: typeof AZURE_ENVS[keyof typeof AZURE_ENVS]) {
    return EnvUtils.getAzureEnv() === azureEnv;
  }

  static nodeEnvIs(nodeEnv: typeof NODE_ENVS[keyof typeof NODE_ENVS]) {
    return EnvUtils.getNodeEnv() === nodeEnv;
  }

  static isDevelopment() {
    return EnvUtils.nodeEnvIs('development') && EnvUtils.azureEnvIs('local');
  }

  static isStaging() {
    return EnvUtils.azureEnvIs('staging');
  }

  static isProduction() {
    return EnvUtils.nodeEnvIs('production');
  }

  static isProRataFirstPeriodEnabled() {
    return process.env.PRORATA_FIRSTPERIOD_ENABLED === 'true';
  }


  static isUpliftRatesEnabled() {
    return process.env.UPLIFT_RATES_ENABLED === 'true';
  }

  static isAlterGlobalSettingsButtonEnabled() {
    return process.env.ALTER_GLOBAL_SETTINGS_BUTTON_ENABLED === 'true';
  }

  static isBillingTabContractHeaderEnabled() {
    return process.env.BILLING_TAB_CONTRACT_HEADER_ENABLED === 'true';
  }


  static isSelectiveBillingEnabled() {
    return process.env.SELECTIVE_BILLING_ENABLED === 'true';
  }

  static isDisableFutureLinePauseEnabled() {
    return process.env.DISABLE_FUTURE_LINE_PAUSE === 'true';
  }

  static isContractLineMergeEnabled() {
    return process.env.CONTRACT_LINE_MERGE_ENABLED === 'true';
  }

  static isNextSoIssueDateEnabled() {
    return process.env.NEXT_SO_ISSUE_DATE_ENABLED === 'true';
  }

  static isContractTCsEnabled() {
    return process.env.CONTRACT_TCS_ENABLED === 'true';
  }


  static isUpliftCapsEnabled() {
    return process.env.UPLIFT_CAPS_ENABLED === 'true';
  }

  static isInstantSendEnabled() {
    return process.env.ENABLE_INSTANT_SEND === 'true';
  }
}
